module.exports = __webpack_public_path__ + "media/images/taxigo-platinum/work1-2951e33a6c5e730e9bc365a7b73398a1.svg";